import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import { saveAs } from 'file-saver'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loading from './Loading'
import { usePDF } from 'react-to-pdf'

export default function Coupon() {
	const [details, setDetails] = useState(null)
	const [error, setError] = useState(null)

	const { coupon } = useParams()

	const { toPDF, targetRef } = usePDF({
		filename: `Coupon - Tick Your Tour`,
		resolution: 5,
		page: { orientation: 'l', format: [224, 83], margin: '8' },
		method: 'open',
		canvas: {
			mimeType: 'image/png',
			qualityRatio: 1,
		},
	})

	// const handleDownload = async () => {
	// 	if (!details) return toast.error('Something went wrong!')
	// 	try {
	// 		// Fetch the existing PDF
	// 		const pdfUrl = '/images/coupon.pdf' // Adjust the path as needed
	// 		const existingPdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer())

	// 		// Load the PDF
	// 		const pdfDoc = await PDFDocument.load(existingPdfBytes)

	// 		// Get the first page of the PDF
	// 		const page = pdfDoc.getPages()[0]
	// 		const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold)

	// 		// Define positions for name and discount value text
	// 		const namePosition1 = { x: 560, y: 280 } // Adjust as necessary
	// 		const discountPosition = { x: 810, y: 35 } // Adjust as necessary
	// 		const namePosition2 = { x: 1360, y: 300 } // Adjust as necessary
	// 		// Add guest name
	// 		page.drawText(details?.guests?.name || '', {
	// 			x: namePosition1.x,
	// 			y: namePosition1.y,
	// 			size: 28,
	// 			font,
	// 			color: rgb(0, 0, 0),
	// 		})
	// 		// Add guest name
	// 		page.drawText(details?.guests?.name || '', {
	// 			x: namePosition2.x,
	// 			y: namePosition2.y,
	// 			size: 28,
	// 			font,
	// 			color: rgb(0, 0, 0),
	// 		})

	// 		// Format discount information
	// 		const discountText = `${details.coupon.coupon_code.discount_value}`
	// 		page.drawText(discountText, {
	// 			x: discountPosition.x,
	// 			y: discountPosition.y,
	// 			size: 64,
	// 			font,
	// 			color: rgb(1, 0, 0),
	// 		})

	// 		// Save the modified PDF
	// 		const pdfBytes = await pdfDoc.save()

	// 		// Trigger file download
	// 		saveAs(
	// 			new Blob([pdfBytes], { type: 'application/pdf' }),
	// 			`coupon_${details?.guests?.name || ''}.pdf`,
	// 		)
	// 	} catch (error) {
	// 		console.error('Error generating PDF:', error)
	// 	}
	// }

	useEffect(() => {
		const fetchCouponDetails = async () => {
			try {
				const response = await axios.get(`/api/applied-coupon/${coupon}/`)
				if (response.statusText === 'OK') setDetails(response.data)
			} catch (err) {
				setError(err.response?.data || 'Error fetching coupon details')
			}
		}

		fetchCouponDetails()
	}, [coupon])

	if (error) return <div>Error: {error}</div>
	if (!details) return <Loading />

	return (
		<div className="py-8 flex flex-col justify-center items-center gap-8 w-full min-h-screen bg-[hsl(223,100%,95%)] mx-auto font-sans ">
			<button
				className="rounded-3xl bg-primary text-white font-semibold px-8 py-2 flex justify-center items-center shadow-sm hover:bg-primary-dark transition-all duration-300 hover:scale-105 active:scale-90 "
				onClick={toPDF}
			>
				Download Coupon
			</button>
			<div ref={targetRef} className="rounded-lg bg-white grid place-items-center px-4 md:px-0">
				<div className="max-w-2xl mx-auto drop-shadow-xl">
					<div className="flex flex-col md:flex-row w-full bg-white rounded-lg overflow-hidden shadow-lg">
						{/* Left Section */}
						<div className="bg-red-700 text-white p-6 flex-[1] text-center">
							<h2 className="text-2xl font-bold mb-4">Long Weekend Special Price Coupons</h2>
							<div className="mb-6">
								{details.coupon.coupon_code.discount_type === 'Percentage' && (
									<p className="text-xl font-bold">
										YOU GET A {parseInt(details.coupon.coupon_code.discount_value)}% DISCOUNT COUPON
										FOR YOUR TRIP!
									</p>
								)}
								{details.coupon.coupon_code.discount_type === 'Fixed' && (
									<p className="text-xl font-bold">
										YOU GET A FLAT ₹{parseInt(details.coupon.coupon_code.discount_value)} DISCOUNT
										COUPON FOR YOUR TRIP!
									</p>
								)}
							</div>
							<div className="text-sm font-medium">
								<p>Condition : Applicable for Only 1</p>
								<p>person in 1 Group</p>
							</div>
						</div>

						{/* Middle Section */}
						<div className="relative bg-transparent z-0 bg-coupon-bg bg-center bg-cover  text-white p-2 flex flex-col items-center justify-center md:w-44">
							<div className="absolute w-full h-full bg-black/60  -z-10"></div>

							<div className="text-4xl font-bold italic flex items-center font-serif">
								<span className="text-3xl">₹</span>
								{parseInt(details.coupon.coupon_code.maximum_discount)}
							</div>

							<p className="font-semibold text-center mt-2 font-serif">Cashback Coupon</p>

							<p className="mt-8 text-white px-6 py-2 rounded-md text-base font-semibold !leading-3 ">
								Min {details.coupon.coupon_code.usage_minimum_person} pax
							</p>
						</div>

						{/* Right Section */}
						<div className="bg-navy-800 bg-primary p-4 flex flex-col items-center justify-between md:w-44">
							<img
								src="https://d1crnb901o7gp8.cloudfront.net/static-group/images+/logo.png"
								className="w-32 h-auto"
								alt=""
							/>

							{/* QR Code Placeholder */}
							<img
								src="https://d1crnb901o7gp8.cloudfront.net/static-group/images+/qr.png"
								className="w-24"
								alt=""
							/>

							<div className="text-white text-center ">
								<p className="text-sm">Your Coupon Code:</p>
								<p className="font-semibold tracking-wide">{details.coupon.coupon_code.code}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
